import React, { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { StyledButton } from './styles';

interface SecondaryButtonProps {
  styleType?: 'default' | 'color' | 'error';
  disabled?: boolean;
  children: ReactNode;
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}

/**
 * A secondary button component that can be used in a form or any other context.
 *
 * @param styleType - The style of the button, which can be either 'default', 'color', or 'error'.
 * @param disabled - Whether the button is disabled or not.
 * @param children - The text or content to display inside the button.
 * @param onClick - A function that will be called when the button is clicked.
 * @param type - The type of the button, which can be either 'submit', 'button', or 'reset'.
 */
const SecondaryButton: FC<SecondaryButtonProps> = ({
  styleType = 'default',
  disabled = false,
  children,
  onClick,
  type,
}) => {
  return (
    <StyledButton
      styleType={styleType}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {children}
    </StyledButton>
  );
};

export default SecondaryButton;
